import { Box, LinearProgress } from "@mui/material";
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import { StatCard } from "./resellerUi";

const OnlineLecs = ({ total, online }) => {
  const t = total ?? 0;
  const o = online ?? 0;
  const pct = t > 0 ? Math.round((o / t) * 100) : 0;

  return (
    <StatCard icon={RouterOutlinedIcon} label="LECS online" value={`${o} / ${t}`}>
      <Box sx={{ mt: 0.75 }}>
        <LinearProgress
          variant="determinate"
          value={pct}
          aria-label="LECS online"
          sx={{
            height: 4,
            borderRadius: 2,
            backgroundColor: "rgba(255,255,255,0.08)",
            "& .MuiLinearProgress-bar": { backgroundColor: "#34a327", borderRadius: 2 },
          }}
        />
      </Box>
    </StatCard>
  );
};

export default OnlineLecs;
